export interface ShareElement {
    inherit: Inherit;
}

export enum Inherit {
    Custom = "CUSTOM",
    Inherit = "INHERIT",
}
